const STORAGE_KEY = "fb_attribution_v1";
const FACEBOOK_SOURCE_REGEX = /facebook|fb|instagram|meta/i;

function normalizeValue(value) {
  if (Array.isArray(value)) {
    return value.length > 0 ? String(value[value.length - 1]) : "";
  }

  if (value === null || value === undefined) {
    return "";
  }

  return String(value);
}

function getEntries(queryLike) {
  if (!queryLike) {
    return [];
  }

  if (typeof URLSearchParams !== "undefined" && queryLike instanceof URLSearchParams) {
    return Array.from(queryLike.entries());
  }

  if (typeof queryLike === "string") {
    const raw = queryLike.startsWith("?") ? queryLike.slice(1) : queryLike;
    return Array.from(new URLSearchParams(raw).entries());
  }

  if (typeof queryLike === "object") {
    return Object.entries(queryLike).map(([key, value]) => [key, normalizeValue(value)]);
  }

  return [];
}

function getValueCaseInsensitive(entries, key) {
  const lowered = key.toLowerCase();
  const match = entries.find(([entryKey]) => String(entryKey).toLowerCase() === lowered);
  return match ? normalizeValue(match[1]) : "";
}

function getStorage() {
  if (typeof window === "undefined" || !window.sessionStorage) {
    return null;
  }

  return window.sessionStorage;
}

function readStoredAttribution() {
  const storage = getStorage();
  if (!storage) {
    return null;
  }

  try {
    const parsed = JSON.parse(storage.getItem(STORAGE_KEY) || "null");
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
      return null;
    }

    return parsed;
  } catch (error) {
    return null;
  }
}

function saveAttribution(payload) {
  const storage = getStorage();
  if (!storage) {
    return;
  }

  try {
    storage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (error) {
    // Intencionalmente no interrumpe el flujo de compra si falla el storage.
  }
}

function isWhitelistedParam(key) {
  const lowered = key.toLowerCase();
  return lowered === "fbclid" || lowered === "audremar" || lowered.startsWith("utm_");
}

function normalizeTrackingKey(key) {
  const lowered = key.toLowerCase();

  if (lowered === "audremar") {
    return "AudRemar";
  }

  if (lowered === "fbclid") {
    return "fbclid";
  }

  if (lowered.startsWith("utm_")) {
    return lowered;
  }

  return key;
}

function isTeachableCheckoutUrl(url) {
  if (!url || typeof url !== "string" || url.startsWith("#")) {
    return false;
  }

  try {
    const parsed = new URL(url, typeof window !== "undefined" ? window.location.origin : undefined);
    const isHttp = parsed.protocol === "http:" || parsed.protocol === "https:";
    const isTeachable = parsed.hostname.endsWith("teachable.com");
    const isCheckout = parsed.pathname.includes("/checkout/");

    return isHttp && isTeachable && isCheckout;
  } catch (error) {
    return false;
  }
}

export function captureFacebookAttribution(queryLike) {
  const entries = getEntries(queryLike);
  if (!entries.length) {
    return;
  }

  const fbclid = getValueCaseInsensitive(entries, "fbclid");
  const utmSource = getValueCaseInsensitive(entries, "utm_source");
  const comesFromFacebook = Boolean(fbclid) || FACEBOOK_SOURCE_REGEX.test(utmSource);

  if (!comesFromFacebook) {
    return;
  }

  const filtered = {};

  entries.forEach(([rawKey, rawValue]) => {
    const key = String(rawKey);
    const value = normalizeValue(rawValue);

    if (!key || !value || !isWhitelistedParam(key)) {
      return;
    }

    filtered[normalizeTrackingKey(key)] = value;
  });

  if (Object.keys(filtered).length === 0) {
    return;
  }

  saveAttribution(filtered);
}

export function appendFacebookAttribution(url) {
  if (!isTeachableCheckoutUrl(url)) {
    return url;
  }

  const storedAttribution = readStoredAttribution();
  if (!storedAttribution) {
    return url;
  }

  try {
    const parsedUrl = new URL(url);

    Object.entries(storedAttribution).forEach(([key, value]) => {
      if (!parsedUrl.searchParams.has(key) && value) {
        parsedUrl.searchParams.append(key, String(value));
      }
    });

    return parsedUrl.toString();
  } catch (error) {
    return url;
  }
}
